module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "FBMHD"
  }, [_vm._v("Tools and Equipment")]), _vm._v(" "), _c('p', {
    staticClass: "CH-INTRO1"
  }, [_vm._v("To make a batch of whoopie pies, you don’t need much more than you’ll find in any domestic kitchen, but if you are planning on trying your hand at decorating, here is a list of the key tools and equipment you might find helpful:")]), _vm._v(" "), _c('p', {
    staticClass: "ML-NL1-1st"
  }, [_vm._v("1. Whoopie pie tin – very useful, but greased baking trays can be used instead")]), _vm._v(" "), _c('p', {
    staticClass: "ML-NL1"
  }, [_vm._v("2. Wire rack – for placing whoopies on to cool")]), _vm._v(" "), _c('p', {
    staticClass: "ML-NL1"
  }, [_vm._v("3. Small ice cream scoop – for measuring batter for perfect-sized whoopies every time")]), _vm._v(" "), _c('p', {
    staticClass: "ML-NL1"
  }, [_vm._v("4. Non-stick rolling pin – for rolling out sugarpaste and petal paste")]), _vm._v(" "), _c('p', {
    staticClass: "ML-NL1"
  }, [_vm._v("5. Paintbrushes – a variety of different sizes are useful for painting, moistening and sticking")]), _vm._v(" "), _c('p', {
    staticClass: "ML-NL1"
  }, [_vm._v("6. Edible glue – for sticking small pieces of icing together")]), _vm._v(" "), _c('p', {
    staticClass: "ML-NL1"
  }, [_vm._v("7. Piping (pastry) bags – small for piping royal icing and large for filling whoopies")]), _vm._v(" "), _c('p', {
    staticClass: "ML-NL1"
  }, [_vm._v("8. Cutters – a variety of cutters are useful for different projects")]), _vm._v(" "), _c('p', {
    staticClass: "ML-NL1"
  }, [_vm._v("9. Drying mat – a great place to dry small sugarpaste pieces")]), _vm._v(" "), _c('p', {
    staticClass: "ML-NL1"
  }, [_vm._v("10. Piping tubes (tips) – for filling, piping and decoration (also known as nozzles)")]), _vm._v(" "), _c('p', {
    staticClass: "ML-NL1"
  }, [_vm._v("11. Palette knife – for lifting delicate sugarpaste pieces")]), _vm._v(" "), _c('p', {
    staticClass: "ML-NL1"
  }, [_vm._v("12. Paste food colours, edible dusts and edible glitters – for colouring, painting and adding sparkle")]), _vm._v(" "), _c('p', {
    staticClass: "ML-NL1"
  }, [_vm._v("13. Craft knife – for accurate detailed cutting")]), _vm._v(" "), _c('p', {
    staticClass: "ML-NL1"
  }, [_vm._v("14. Cocktail sticks (toothpicks) – great for adding tiny amounts of colour and for frilling")]), _vm._v(" "), _c('p', {
    staticClass: "ML-NL1"
  }, [_vm._v("15. Measuring spoons – for measuring ingredients quickly and accurately")]), _vm._v(" "), _c('p', {
    staticClass: "ML-NL1-last"
  }, [_vm._v("16. Sugar shaker – for dusting your surface with icing (confectioners’) sugar to prevent sticking")]), _vm._v(" "), _c('p', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/tools_fmt.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6b741ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c02.vue
// module id = 66
// module chunks = 0